import { useTranslation } from "react-i18next";
import SegmentedToggle from "../../components/SegmentedToggle";
import { DayOfWeek } from "./contracts/DayOfWeek";

interface WeekStartSelectorProps {
  value: DayOfWeek;
  onChange: (value: DayOfWeek) => void;
}

/** Monday/Sunday toggle for how the calendar lays out the week. */
const WeekStartSelector = ({ value, onChange }: WeekStartSelectorProps) => {
  const { t } = useTranslation();

  return (
    <div className="border-t border-grey-80 dark:border-grey-50 pt-5 space-y-2">
      <p className="text-sm font-semibold text-grey-30 dark:text-grey-90">
        {t("schedulePreferences.weekStartTitle")}
      </p>
      <p className="text-sm text-grey-50 dark:text-grey-70">
        {t("schedulePreferences.weekStartDescription")}
      </p>
      <SegmentedToggle
        value={value}
        onChange={onChange}
        options={[
          { value: DayOfWeek.Monday, label: t("schedulePreferences.monday") },
          { value: DayOfWeek.Sunday, label: t("schedulePreferences.sunday") },
        ]}
      />
    </div>
  );
};

export default WeekStartSelector;
